export default __webpack_public_path__ + "static/media/generalInsurance_final-min.6dce838e.jpg";